import { TaggedError } from "@for-it/domain-lib";
export class CertificationNotFoundError extends TaggedError {
    constructor() {
        super("CERTIFICATION_NOT_FOUND", "Certification not found.");
    }
}
